import { render, staticRenderFns } from "./EventSubTypeList.vue?vue&type=template&id=b6eec56e"
import script from "./EventSubTypeList.vue?vue&type=script&lang=js"
export * from "./EventSubTypeList.vue?vue&type=script&lang=js"
import style0 from "./EventSubTypeList.vue?vue&type=style&index=0&id=b6eec56e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports